/**
 * VeyoActive Custom JS
 * Uses Slick Carousel (like HTML template) when jQuery + Slick are available;
 * falls back to CSS scroll-snap + vanilla JS arrow navigation otherwise.
 */

function getSlickOptions(track) {
  var container = track.closest('.veyo-collection-section') || track.closest('.product-recommendations') || track.closest('section');
  if (!container) return null;
  var prevArrow = container.querySelector('.veyo-nav-arrow--prev');
  var nextArrow = container.querySelector('.veyo-nav-arrow--next');

  var base = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    dots: false
  };

  var list = track.closest('.veyo-collection-section');
  var featured = track.closest('.veyo-featured-banner');
  var trending = track.closest('.veyo-trending-section');
  var category = track.closest('.veyo-category-section');
  var testimonials = track.closest('.veyo-testimonials-section');
  var productRecs = track.closest('.product-recommendations');

  if (list || productRecs) {
    return Object.assign({}, base, {
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 2 } }
      ]
    });
  }

  if (featured) {
    return Object.assign({}, base, {
      slidesToShow: 3,
      arrows: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3, arrows: true, prevArrow: prevArrow, nextArrow: nextArrow } },
        { breakpoint: 768, settings: { slidesToShow: 2, arrows: true, prevArrow: prevArrow, nextArrow: nextArrow } },
        { breakpoint: 480, settings: { slidesToShow: 2, arrows: true, prevArrow: prevArrow, nextArrow: nextArrow } }
      ]
    });
  }

  if (trending) {
    return Object.assign({}, base, {
      centerMode: true,
      centerPadding: '10%',
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3, centerPadding: '5%' } },
        { breakpoint: 768, settings: { slidesToShow: 1, centerMode: false, centerPadding: '0' } },
        { breakpoint: 480, settings: { slidesToShow: 1, centerMode: false, centerPadding: '0' } }
      ]
    });
  }

  if (category) {
    return Object.assign({}, base, {
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1 } }
      ]
    });
  }

  if (testimonials) {
    return Object.assign({}, base, {
      slidesToShow: 3,
      arrows: false,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 1, arrows: true, prevArrow: prevArrow, nextArrow: nextArrow } }
      ]
    });
  }

  return null;
}

function initVeyoSlick() {
  if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return false;
  var $ = window.jQuery;

  var selectors = [
    '.veyo-collection-section .veyo-carousel-track',
    '.veyo-featured-banner .veyo-carousel-track',
    '.veyo-trending-section .veyo-carousel-track',
    '.veyo-category-section .veyo-carousel-track',
    '.veyo-testimonials-section .veyo-carousel-track',
    '.product-recommendations .veyo-carousel-track'
  ];

  selectors.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (track) {
      if (track.classList.contains('slick-initialized')) return;
      var opts = getSlickOptions(track);
      if (opts) $(track).slick(opts);
    });
  });

  // Coaching hero slider
  var coachingSlider = document.querySelector('.coaching-hero-slider');
  if (coachingSlider && !coachingSlider.classList.contains('slick-initialized')) {
    $(coachingSlider).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 4000,
      centerMode: true,
      centerPadding: '60px',
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 1, centerMode: true, centerPadding: '80px' } },
        { breakpoint: 768, settings: { slidesToShow: 1, centerMode: true, centerPadding: '60px' } },
        { breakpoint: 480, settings: { slidesToShow: 1, centerMode: true, centerPadding: '40px' } }
      ]
    });
  }

  return true;
}

function destroyVeyoSlickInSection(sectionEl) {
  if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return;
  var $ = window.jQuery;
  sectionEl.querySelectorAll('.veyo-carousel-track.slick-initialized').forEach(function (track) {
    $(track).slick('unslick');
  });
}

// Fallback: CSS scroll-snap carousels with vanilla JS arrow navigation
class VeyoCarousel {
  constructor(sectionEl) {
    this.section = sectionEl;
    this.track = sectionEl.querySelector('.veyo-carousel-track');
    if (!this.track) return;

    this.prevBtn = sectionEl.querySelector('.veyo-nav-arrow--prev');
    this.nextBtn = sectionEl.querySelector('.veyo-nav-arrow--next');

    this.init();
  }

  init() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.scroll(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.scroll(1));
    }
  }

  scroll(direction) {
    const card = this.track.querySelector('.veyo-carousel-track > *');
    if (!card) return;
    const scrollAmount = card.offsetWidth + parseInt(getComputedStyle(this.track).gap || 0);
    this.track.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  }
}

// Mobile menu - drop down panel with submenu support
function initMobileMenu() {
  var toggleBtn = document.querySelector('[data-veyo-menu-toggle]');
  var menu = document.querySelector('[data-veyo-mobile-menu]');
  var overlay = document.querySelector('[data-veyo-mobile-overlay]');
  if (!toggleBtn || !menu) return;

  var submenus = document.querySelectorAll('[data-veyo-mobile-submenu]');

  function closeMobileMenu() {
    toggleBtn.classList.remove('active');
    menu.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    submenus.forEach(function (sub) { sub.classList.remove('active'); });
    document.body.style.overflow = '';
  }

  toggleBtn.addEventListener('click', function () {
    if (menu.classList.contains('active')) {
      closeMobileMenu();
    } else {
      menu.classList.add('active');
      if (overlay) overlay.classList.add('active');
      toggleBtn.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  });

  if (overlay) {
    overlay.addEventListener('click', closeMobileMenu);
  }

  document.querySelectorAll('[data-veyo-open-submenu]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-veyo-open-submenu');
      var submenu = document.querySelector('[data-veyo-mobile-submenu="' + target + '"]');
      if (submenu) submenu.classList.add('active');
    });
  });

  document.querySelectorAll('[data-veyo-close-submenu]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var submenu = btn.closest('[data-veyo-mobile-submenu]');
      if (submenu) submenu.classList.remove('active');
    });
  });
}

function initHeaderStuck() {
  var announcement = document.querySelector('.veyo-announcement-bar');
  if (!announcement) return;

  function handleScroll() {
    var announcementHeight = announcement.offsetHeight;
    if (window.scrollY >= announcementHeight) {
      document.body.classList.add('veyo-header-stuck');
    } else {
      document.body.classList.remove('veyo-header-stuck');
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

// Update veyo cart count when cart changes (add to cart, etc.)
function initVeyoCartCount() {
  var countEl = document.querySelector('[data-veyo-cart-count]');
  if (!countEl) return;

  function updateCount(itemCount) {
    countEl.textContent = itemCount;
    countEl.style.display = '';
    countEl.parentElement.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
  }

  document.addEventListener('cart:update', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count || 0);
      })
      .catch(function () {});
  });
}

function initFooterAccordion() {
  document.querySelectorAll('.veyo-footer-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });
}

/**
 * Color dot hover: swap product card image to variant image on color dot hover.
 * Reverts to main image when pointer leaves the color options area. Main image hover (second angle/zoom) works normally.
 */
function initVeyoColorDotHover() {
  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest && e.target.closest('a.veyo-color-dot[data-variant-image-url]');
    if (!dot) return;
    var card = dot.closest('.veyo-product-card');
    if (!card) return;
    var primaryImg = card.querySelector('.veyo-product-image img[data-default-image-url]:not(.veyo-hover-img)');
    if (!primaryImg) return;
    var url = dot.getAttribute('data-variant-image-url');
    if (!url) return;
    primaryImg.src = url;
    card.classList.add('veyo-product-card--color-dot-active');
  }, true);

  function revertCardImage(card) {
    if (!card) return;
    var primaryImg = card.querySelector('.veyo-product-image img[data-default-image-url]:not(.veyo-hover-img)');
    if (primaryImg) {
      primaryImg.src = primaryImg.getAttribute('data-default-image-url') || primaryImg.src;
    }
    card.classList.remove('veyo-product-card--color-dot-active');
  }

  function bindColorOptions(options) {
    if (options.getAttribute('data-veyo-color-dot-bound')) return;
    options.setAttribute('data-veyo-color-dot-bound', '1');
    options.addEventListener('mouseleave', function () {
      revertCardImage(options.closest('.veyo-product-card'));
    });
  }

  document.querySelectorAll('.veyo-product-card .veyo-color-options').forEach(bindColorOptions);

  var observer = new MutationObserver(function () {
    document.querySelectorAll('.veyo-product-card .veyo-color-options:not([data-veyo-color-dot-bound])').forEach(bindColorOptions);
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

function initHashtagSlider() {
  if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return;
  var $ = window.jQuery;
  var $grid = $('.veyo-hashtag-section .veyo-hashtag-grid');
  if (!$grid.length) return;
  if (window.innerWidth < 768) {
    if (!$grid.hasClass('slick-initialized')) {
      $grid.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: true,
        centerPadding: '10%',
        responsive: [
          { breakpoint: 480, settings: { slidesToShow: 2 } }
        ]
      });
    }
  } else {
    if ($grid.hasClass('slick-initialized')) {
      $grid.slick('unslick');
    }
  }
}

function initCarousels() {
  if (initVeyoSlick()) return;
  document.querySelectorAll('[data-veyo-carousel]').forEach(function (el) {
    new VeyoCarousel(el);
  });
}

function onReady() {
  initVeyoCartCount();
  initFooterAccordion();
  initMobileMenu();
  initHeaderStuck();
  initVeyoColorDotHover();
  // Slick loads after us (defer); retry until jQuery + Slick exist, then init carousels
  function tryCarousels() {
    if (typeof window.jQuery !== 'undefined' && window.jQuery.fn.slick) {
      initCarousels();
      initHashtagSlider();
      return;
    }
    setTimeout(tryCarousels, 30);
  }
  tryCarousels();

  // Re-init Slick when product-recommendations loads content asynchronously
  (function () {
    var timeout;
    function scheduleInit() {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        if (typeof window.jQuery !== 'undefined' && window.jQuery.fn.slick) initVeyoSlick();
      }, 200);
    }
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) scheduleInit();
        if (m.type === 'attributes' && m.attributeName === 'data-recommendations-performed') scheduleInit();
      }
    });
    document.querySelectorAll('product-recommendations').forEach(function (el) {
      observer.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-recommendations-performed'] });
    });
    // Retry once after 2s in case recommendations load before observer is attached
    setTimeout(function () {
      if (document.querySelector('.product-recommendations .veyo-carousel-track:not(.slick-initialized)') && typeof window.jQuery !== 'undefined' && window.jQuery.fn.slick) initVeyoSlick();
    }, 2000);
  })();

  window.addEventListener('resize', function () {
    if (typeof window.jQuery !== 'undefined' && window.jQuery.fn.slick) initHashtagSlider();
  });

  // ========== Size Chart Popup (per-product metafield, page, or global) ==========
  (function () {
    var overlay = document.getElementById('sizeChartPopup');
    var closeBtn = document.getElementById('sizeChartClose');
    var iframeWrap = document.getElementById('sizeChartIframeWrap');
    var iframe = document.getElementById('sizeChartIframe');
    var tableWrap = document.getElementById('sizeChartTableWrap');
    var defaultTableWrapHTML = null;
    if (!overlay) return;

    function openSizeChart(e) {
      if (e) e.preventDefault();
      var trigger = e && e.target && e.target.closest ? e.target.closest('.size-chart-link') : document.querySelector('.size-chart-link');
      var url = trigger && trigger.getAttribute('data-size-guide-url');
      if (!url) url = overlay.getAttribute('data-global-size-guide-url') || '';
      var useRichText = trigger && trigger.getAttribute('data-size-guide-rich') === 'true';
      var useProductTable = trigger && trigger.getAttribute('data-size-guide-product-table') === 'true';
      var useVariantTable = trigger && trigger.getAttribute('data-size-guide-variant') === 'true';
      var wrapper = trigger && trigger.closest && trigger.closest('.size-chart-link-wrapper');
      var richTextEl = wrapper && wrapper.querySelector('.size-guide-product-richtext');
      var productTableEl = wrapper && wrapper.querySelector('.size-guide-product-table');
      var variantTableEl = wrapper && wrapper.querySelector('.size-guide-variant-table');

      if (url && iframe) {
        iframe.src = url;
        if (iframeWrap) iframeWrap.hidden = false;
        if (tableWrap) tableWrap.hidden = true;
      } else if (useRichText && richTextEl && tableWrap) {
        if (iframe) iframe.src = '';
        if (iframeWrap) iframeWrap.hidden = true;
        if (defaultTableWrapHTML === null) defaultTableWrapHTML = tableWrap.innerHTML;
        tableWrap.innerHTML = richTextEl.innerHTML.trim() ? '<div class="size-chart-popup__custom-content">' + richTextEl.innerHTML + '</div>' : defaultTableWrapHTML;
        tableWrap.hidden = false;
      } else if (useProductTable && productTableEl && tableWrap && productTableEl.innerHTML.trim()) {
        if (iframe) iframe.src = '';
        if (iframeWrap) iframeWrap.hidden = true;
        if (defaultTableWrapHTML === null) defaultTableWrapHTML = tableWrap.innerHTML;
        tableWrap.innerHTML = '<div class="size-chart-popup__custom-content">' + productTableEl.innerHTML + '</div>';
        tableWrap.hidden = false;
      } else if (useVariantTable && variantTableEl && tableWrap && variantTableEl.innerHTML.trim()) {
        if (iframe) iframe.src = '';
        if (iframeWrap) iframeWrap.hidden = true;
        if (defaultTableWrapHTML === null) defaultTableWrapHTML = tableWrap.innerHTML;
        tableWrap.innerHTML = '<div class="size-chart-popup__custom-content">' + variantTableEl.innerHTML + '</div>';
        tableWrap.hidden = false;
      } else {
        if (iframe) iframe.src = '';
        if (iframeWrap) iframeWrap.hidden = true;
        if (tableWrap) {
          if (defaultTableWrapHTML !== null) tableWrap.innerHTML = defaultTableWrapHTML;
          tableWrap.hidden = false;
        }
      }

      var titleEl = overlay.querySelector('.size-chart-popup__title');
      var subtitleEl = overlay.querySelector('.size-chart-popup__subtitle');
      var defaultTitle = overlay.getAttribute('data-default-title') || 'Size guide';
      var defaultSubtitle = overlay.getAttribute('data-default-subtitle') || '';
      if (titleEl) titleEl.textContent = (trigger && trigger.getAttribute('data-size-guide-title')) || defaultTitle;
      if (subtitleEl) {
        var subText = (trigger && trigger.getAttribute('data-size-guide-description')) || defaultSubtitle;
        subtitleEl.textContent = subText;
        subtitleEl.hidden = !subText;
      }

      overlay.classList.add('is-active');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function closeSizeChart() {
      overlay.classList.remove('is-active');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var trigger = document.querySelector('.size-chart-link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (iframe) iframe.src = '';
      if (iframeWrap) iframeWrap.hidden = true;
      if (tableWrap && defaultTableWrapHTML !== null) tableWrap.innerHTML = defaultTableWrapHTML;
      if (tableWrap) tableWrap.hidden = false;
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.size-chart-link')) openSizeChart(e);
    });
    if (closeBtn) closeBtn.addEventListener('click', closeSizeChart);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeSizeChart();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
        closeSizeChart();
      }
    });
  })();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', onReady);
} else {
  onReady();
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    destroyVeyoSlickInSection(section);
    if (section.classList.contains('veyo-hashtag-section')) {
      initHashtagSlider();
    }
    if (initVeyoSlick()) return;
    if (section.querySelector('[data-veyo-carousel]')) {
      section.querySelectorAll('[data-veyo-carousel]').forEach(function (el) {
        new VeyoCarousel(el);
      });
    }
  });
}
/* VEYO SCROLL REVEAL */

document.addEventListener("DOMContentLoaded", () => {

  const elements = document.querySelectorAll(`
    .shopify-section,
    .card,
    .product-card,
    .collection-card,
    .image-banner,
    .multicolumn-card
  `);

  elements.forEach((el) => {
    el.classList.add("fade-up");
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {

      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
      }

    });
  }, {
    threshold: 0.12
  });

  elements.forEach((el) => observer.observe(el));

});
